import NotificationLinksPage from "../NotificationLinksPage/NotificationLinksPage";

export default NotificationLinksPage;